export default function AboutSection() {
  return (
    <section id="was-ist" className="py-16 md:py-20">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          {/* Left Content */}
          <div className="lg:col-span-7">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-6">
              Was ist ein OOPBUY Spreadsheet?
            </h2>
            <div className="text-sm md:text-base text-foreground-700 leading-relaxed space-y-4 max-w-xl">
              <p>
                Ein <strong>OOPBUY Spreadsheet</strong> ist eine strukturierte Produkt&uuml;bersicht, mit der K&auml;ufer interessante Produkte schneller finden, vergleichen und organisieren k&ouml;nnen. Das <strong>oopbuy spreadsheet</strong> wurde speziell f&uuml;r den deutschsprachigen Markt entwickelt und bietet eine umfassende Datenbank mit tausenden gepr&uuml;ften Artikeln aus verschiedenen Kategorien.
              </p>
              <p>
                Im Gegensatz zur klassischen Suche erm&ouml;glicht das <strong>oopbuy spreadsheet deutsch</strong> einen direkten Vergleich von Preisen, Qualit&auml;t und Verk&auml;uferbewertungen &ndash; alles an einem Ort. Besonders f&uuml;r Einsteiger ist die <strong>oopbuy liste</strong> eine unverzichtbare Ressource, um den &Uuml;berblick zu behalten und fundierte Kaufentscheidungen zu treffen.
              </p>
              <p>
                Die aktuelle Version des <strong>oopbuy spreadsheet 2026</strong> enth&auml;lt verbesserte Filterfunktionen, erweiterte Kategorien und detaillierte Sicherheitsinformationen, die auf echten <strong>oopbuy erfahrung</strong>en basieren. Unser Team aktualisiert die Datenbank regelm&auml;&szlig;ig, um dir stets die aktuellsten und relevantesten Produkte zu pr&auml;sentieren.
              </p>
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-primary-100 text-primary-700 rounded-full text-sm font-semibold hover:bg-primary-200 transition-colors whitespace-nowrap cursor-pointer"
            >
              OOPBUY Spreadsheet entdecken
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </a>
          </div>

          {/* Right Image Card */}
          <div className="lg:col-span-5">
            <div className="relative rounded-3xl overflow-hidden h-[420px] bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20desk%20setup%20with%20laptop%20displaying%20colorful%20product%20catalog%20grid%20surrounded%20by%20curated%20fashion%20items%20including%20premium%20sneakers%20and%20leather%20accessories%2C%20soft%20natural%20daylight%20through%20large%20window%2C%20warm%20wooden%20surface%2C%20editorial%20workspace%20photography%2C%20clean%20productive%20aesthetic%2C%20harmonious%20warm%20neutral%20tones%2C%20lifestyle%20creative%20studio%20atmosphere&width=800&height=1000&seq=about-card-v2-01&orientation=portrait"
                alt="OOPBUY Spreadsheet Shopping Guide"
                title="OOPBUY Spreadsheet Deutschland Guide"
                className="w-full h-full object-cover"
              />
              <div className="absolute top-4 left-4 px-4 py-1.5 bg-background-50/90 backdrop-blur-sm rounded-full">
                <span className="text-xs font-medium text-foreground-800">Shopping Guide</span>
              </div>
              <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-foreground-900/60 to-transparent"></div>
              <div className="absolute bottom-6 left-6">
                <p className="text-background-50 text-lg font-semibold">OOPBUY Spreadsheet 2026</p>
                <p className="text-background-200 text-sm">Kompletter Guide auf Deutsch</p>
              </div>
            </div>
          </div>
        </div>

        {/* Comparison Table */}
        <div className="mt-16" id="vergleich">
          <h3 className="font-heading text-2xl font-bold text-foreground-900 mb-6">
            OOPBUY Spreadsheet vs klassische Suche
          </h3>
          <div className="overflow-x-auto rounded-xl border border-background-200/70">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-background-100">
                  <th className="text-left px-6 py-4 font-semibold text-foreground-800">Methode</th>
                  <th className="text-left px-6 py-4 font-semibold text-foreground-800">Geschwindigkeit</th>
                  <th className="text-left px-6 py-4 font-semibold text-foreground-800">&Uuml;bersicht</th>
                  <th className="text-left px-6 py-4 font-semibold text-foreground-800">Sicherheit</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-background-200/50">
                <tr className="hover:bg-background-50 transition-colors">
                  <td className="px-6 py-4 font-medium text-primary-700">Spreadsheet</td>
                  <td className="px-6 py-4 text-foreground-700">Hoch</td>
                  <td className="px-6 py-4 text-foreground-700">Sehr gut</td>
                  <td className="px-6 py-4 text-foreground-700">Gepr&uuml;ft</td>
                </tr>
                <tr className="hover:bg-background-50 transition-colors">
                  <td className="px-6 py-4 font-medium text-foreground-700">Normale Suche</td>
                  <td className="px-6 py-4 text-foreground-600">Mittel</td>
                  <td className="px-6 py-4 text-foreground-600">Schwierig</td>
                  <td className="px-6 py-4 text-foreground-600">Variabel</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}